import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetActivityLogsByWorkspace } from '@/api/workspaces/useGetActivityLogsByWorkspace';
import ActivityLogsLoader from '@/component-library/primitives/Loaders/ActivityLogsLoader';
import NoDataBoard from '@/component-library/widgets/NoDataBoard/NoDataBoard';
import SearchField from '@/component-library/widgets/SearchField/SearchField';
import Table from '@/component-library/widgets/Table/Table';
import { ActivityLog } from '@/models/ActivityLogsByWorkspace';

import { useActivityLogsTable } from './useActivityLogsTable';

const ActivityLogs = () => {
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const { data, isLoading } = useGetActivityLogsByWorkspace(pagination);
  const columns = useActivityLogsTable();
  const [filterValue, setFilterValue] = useState('');

  const logs = data?.logs ?? [];

  const filteredData = useMemo(() => {
    if (!logs.length) return [];
    return logs.filter((row) =>
      Object.values(row).some(
        (value) => value !== null && value.toString().toLowerCase().includes(filterValue.toLowerCase()),
      ),
    );
  }, [logs, filterValue]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row items-center mb-4">
        <div className="flex-grow justify-start">
          <SearchField initialValue={filterValue} setSearchValue={setFilterValue} />
        </div>
      </div>
      {isLoading ? (
        <ActivityLogsLoader />
      ) : filteredData && filteredData.length > 0 ? (
        <Table
          columns={columns}
          data={filteredData ?? []}
          serverPagination={{
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            totalRowCount: data?.total ?? 0,
            onPaginationChange: (updater) => {
              setPagination((prev) => {
                const next = typeof updater === 'function' ? updater(prev) : updater;
                return { pageIndex: next.pageIndex, pageSize: next.pageSize };
              });
            },
          }}
        />
      ) : (
        <NoDataBoard description={t('NoDataBoard.startUsingOurSDK')} />
      )}
    </div>
  );
};

export default ActivityLogs;
